import serverAPI from '@/services/serverAPI'

/**
 * @param {Store}        context
 * @param {Store.commit} context.commit
 */
const fetchProfileSettings = async ({ commit }) => {
  const response = await serverAPI.fetchProfileSettings()

  commit('setProfileTimezone', response.timezone)

  if (response.landing_page_preferences) {
    commit('setLandingPagePreferences', response.landing_page_preferences)
  }
}

/**
 * @param {Store}        context
 * @param {Store.commit} context.commit
 * @param {Store.state}  context.state
 * @param {object}       payload
 * @param {string}       [payload.homePage] - The new library_type value.
 * @param {number|'ALL'} [payload.team]     - The new team ID, or 'ALL' for no filter.
 * @param {string}       [payload.timezone] - The new timezone value.
 */
const updateProfileSettings = async ({ commit, state }, payload) => {
  const body = {}

  if ('timezone' in payload) {
    body.timezone = payload.timezone
  }

  if ('homePage' in payload || 'team' in payload) {
    const teamValue = 'team' in payload ? payload.team : state.landingPagePreferences.team
    const libraryType = 'homePage' in payload ? payload.homePage : state.landingPagePreferences.library_type

    // The backend represents "ALL teams" as null on the landing_page_team FK.
    body.landing_page_team = teamValue === 'ALL' ? null : teamValue
    body.landing_page_library_type = libraryType
  }

  const response = await serverAPI.updateProfileSettings(body)

  if (response.timezone) {
    commit('setProfileTimezone', response.timezone)
  }

  if (response.landing_page_preferences) {
    commit('setLandingPagePreferences', response.landing_page_preferences)
  }
}

export default {
  fetchProfileSettings,
  updateProfileSettings
}
